import { BaseQueryBuilder } from "./base-query-builder";
import { LookupClientService } from "../../../../../../../../services/lookups/lookup-client.service";
import { CustomerService } from "../../../../../../../../services/modules/customer-client.service";
import { ManageRightShipUsersClientService } from "../../../../../../../../services/modules/righship-qi-manage-users.service";
import { autoinject, computedFrom, transient } from "aurelia-framework";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

class FormQueryFilter {
    date: string;
}

@autoinject
@transient()
export class VettingruleformsQueryBuilder extends BaseQueryBuilder<FormQueryFilter> {
    
    constructor(lookupService: LookupClientService, customerService: CustomerService,
        manageRightShipUsersClientService: ManageRightShipUsersClientService, protected configService: ConfigService) {
        super(lookupService, customerService, manageRightShipUsersClientService, configService);
    }

    itemSource: { name: string; id: number; mapping: string; }[] = [
        {name: "days", id: 1, mapping: "today"},
        {name: "weeks", id: 1, mapping: "week"},
        {name: "months", id: 2, mapping: "month"},
        {name: "years", id: 3, mapping: "year"}
    ];

    @computedFrom(Reflection.getPropertyPath<VettingruleformsQueryBuilder>(z => z.filter),
        Reflection.getPropertyPath<VettingruleformsQueryBuilder>(z => z.filter.date))
    get date() {
        if (this.filter.date) {
            const s = this.filter.date.split(" - ");
            return s.length > 1 ? s[1] : "";
        }

        return "";
    }

    @computedFrom(Reflection.getPropertyPath<VettingruleformsQueryBuilder>(z => z.filter),
        Reflection.getPropertyPath<VettingruleformsQueryBuilder>(z => z.filter.date))
    get day() {
        if (this.filter.date) {
            const s = this.filter.date.split(" - ");
            return s.length > 0 ? s[0] : null;
        }

        return null;
    }

    set day(x: string) {
        this.filter.date = this.date ? `${x} - ${this.date}` : x;
    }

    set date(x: string) {
        if (this.day) {
            this.filter.date = `${this.day} - ${x}`;
        }
    }
}